<template>
  <section>
    <b-modal
      ref='modalWhatsAppMessage'
      id='modalWhatsAppMessage'
      hide-header
      header-bg-variant='info'
      header-text-variant='light'
      size='xl'
      scrollable
      @show='showModal()'
      @hide="$emit('update')"
    >
      <b-overlay
        :show="loadingOverlay"
        rounded
        opacity="0.6"
        spinner-small
        spinner-variant="primary"
        class="d-inline-block w-100"
        style="min-height: 100px"
      >
        <section class='modal-font-family modal-instructional-videos'>
          <section class='d-flex justify-content-between align-items-start w-100 header '>
            <section>
              <p v-if="whatsAppMessageId" class='title mb-0'>Editar mensagem de WhatsApp</p>
              <p v-else class='title mb-0'>Adicionar mensagem de WhatsApp</p>
              <span class="sub-title">Preencha os campos abaixo para adicionar a mensagem de WhatsApp</span>
            </section>

            <section>
              <b-icon
                @click='closeModalInstructionalVideos()'
                class='cursor-pointer'
                font-scale='2.5'
                icon='x'
                color='#022245'
              >
              </b-icon>
            </section>
          </section>

          <section>
            <hr />
          </section>

          <section class=''>
            <section>
              <label class="pr-1 mb-1" for="filePhones">Importar lista de telefones</label>
              <a class="pl-1 link-model" href="https://files-hofacil.s3.amazonaws.com/1772153091752">Baixar arquivo
                modelo</a>
            </section>

            <input type='file' id='filePhones' accept='.xlsx' @change='uploadPhones' hidden />
            <label class='file-product d-flex align-items-center' for='filePhones'>
              <svg class='mx-1' width='18' height='18' viewBox='0 0 10 18' fill='none'
                   xmlns='http://www.w3.org/2000/svg'>
                <path
                  d='M3.12969 6.00003V12.743C3.13748 13.2361 3.33882 13.7063 3.69026 14.0523C4.0417 14.3982 4.51507 14.5921 5.0082 14.5921C5.50134 14.5921 5.9747 14.3982 6.32615 14.0523C6.67759 13.7063 6.87893 13.2361 6.88672 12.743L6.89281 3.90472C6.89792 3.48328 6.81933 3.06502 6.66159 2.67418C6.50385 2.28334 6.2701 1.9277 5.97389 1.62787C5.67768 1.32804 5.3249 1.09 4.93601 0.927526C4.54711 0.765056 4.12983 0.681396 3.70836 0.681396C3.28689 0.681396 2.86961 0.765056 2.48071 0.927526C2.09182 1.09 1.73904 1.32804 1.44283 1.62787C1.14661 1.9277 0.912864 2.28334 0.755124 2.67418C0.597384 3.06502 0.518793 3.48328 0.523906 3.90472V12.8025C0.51532 13.3959 0.624765 13.985 0.84588 14.5356C1.067 15.0863 1.39537 15.5875 1.81191 16.0101C2.22845 16.4327 2.72484 16.7683 3.27223 16.9973C3.81962 17.2264 4.40709 17.3443 5.00047 17.3443C5.59385 17.3443 6.18132 17.2264 6.72871 16.9973C7.2761 16.7683 7.77249 16.4327 8.18903 16.0101C8.60557 15.5875 8.93394 15.0863 9.15506 14.5356C9.37617 13.985 9.48562 13.3959 9.47703 12.8025V4.48785'
                  stroke='#808080' stroke-miterlimit='10' stroke-linecap='round' />
              </svg>

              <strong v-if='filePhones && filePhones.name'>{{ filePhones.name }}</strong>

              <span v-if='!filePhones.name'>Clique aqui para anexar o arquivo.</span>
            </label>

            <b-alert show variant="warning" class="d-flex align-items-center mb-0 mt-2">
              Caso o arquivo contenha mais de uma aba, somente a primeira será processada. As demais serão desconsideradas.
            </b-alert>

            <section v-if="phones && phones.length > 0" class="mt-4">
              <section class="d-flex align-items-center">
                <h5><strong>Telefones</strong></h5>

                <b-tooltip target="deletePhones" triggers="hover" placement="top">
                  Excluir telefones
                </b-tooltip>

                <b-icon
                  @click="deletePhones()"
                  id="deletePhones"
                  class="mb-1 ml-2 cursor-pointer"
                  icon="trash"
                  variant="danger"
                ></b-icon>
              </section>
              <ul class="ml-3 phones-grid">
                <li v-for="(phone, index) in phones" :key="index">
                  {{ formatPhone(phone) }}
                </li>
              </ul>
              <hr />
            </section>
          </section>

          <section class="mt-4">
            <section class="mb-2">
              <label for="triggerTags">Tags de gatilho</label>
              <b-tooltip target="tagExport" triggers="hover" placement="top">
                Exportar tag
              </b-tooltip>
              <b-icon v-if="whatsAppMessage.triggerTag" id='tagExport' class="cursor-pointer ml-2"
                      @click="exportToExcel()" icon="file-excel-fill"></b-icon>
            </section>

            <b-form-select
              id="triggerTags"
              v-model="whatsAppMessage.triggerTag"
              :options='tagsInstructionalVideos'
              value-field='tag'
              text-field='tagDescription'
            >
            </b-form-select>
          </section>

          <section class="mt-4">
            <label for="templateName" class="mb-1">Modelo de mensagem (WhatsApp Oficial)</label>
            <b-form-select
              id="templateName"
              v-model="whatsAppMessage.templateName"
              :options='templates'
              value-field='name'
              text-field='label'
              @change='onSelectTemplate'
            >
              <template #first>
                <b-form-select-option :value='null' disabled>Selecione um modelo</b-form-select-option>
              </template>
            </b-form-select>
          </section>

          <section v-if="requiresHeaderMedia" class="mt-4">
            <label for="headerFile" class="mb-1">{{ headerLabel }}</label>

            <input
              type='file'
              id='headerFile'
              :accept='headerAccept'
              @change='uploadHeaderFile'
              hidden
            />

            <b-overlay
              :show="headerFileUploading"
              rounded
              opacity="0.6"
              spinner-small
              spinner-variant="primary"
              class="d-inline-block w-100"
            >
              <label class='file-product d-flex align-items-center' for='headerFile'>
                <b-icon class='mx-2' icon='paperclip'></b-icon>
                <strong v-if='headerFile && headerFile.name'>{{ headerFile.name }}</strong>
                <span v-else>Clique aqui para anexar o arquivo.</span>
              </label>
            </b-overlay>

            <b-form-text>
              Formato exigido pelo modelo: {{ selectedTemplateHeaderFormat }} · Tamanho máximo: {{ headerMaxSizeMb }} MB.
              O arquivo é reenviado a cada disparo deste modelo.
            </b-form-text>
          </section>

          <section class="mt-4">
            <label for="message" class="mb-1">Corpo da mensagem</label>
            <b-form-textarea
              id="message"
              v-model="whatsAppMessage.message"
              readonly
              placeholder="Selecione um modelo para visualizar o corpo da mensagem"
            >
            </b-form-textarea>
          </section>
        </section>

        <template v-slot:overlay>
          <div class="text-center loading-spinner">
            <b-spinner
              style="width: 3rem; height: 3rem"
              variant="primary"
              label="Large Spinner"
            ></b-spinner>
            <h5 class="text-primary">Buscando...</h5>
          </div>
        </template>
      </b-overlay>

      <template #modal-footer>
        <section class="modal-font-family w-100">
          <section class="w-100">
            <b-alert
              show
              variant='danger'
              :class='{ hidden: !errors }'
            >
              {{ errors }}
            </b-alert>
          </section>

          <section class="d-flex justify-content-between w-100">
            <base-button @click="closeModalInstructionalVideos()" class="w-50 mr-3 btn-cancel">
              <span>Cancelar</span>
            </base-button>

            <b-overlay
              :show="loading"
              rounded
              opacity="0.6"
              spinner-small
              spinner-variant="primary"
              class="d-inline-block w-50"
            >
              <base-button
                class="w-100 btn-add d-flex align-items-center justify-content-center"
                @click="submit()"
                :disabled="loading"
              >
                <span v-if="whatsAppMessageId" class="mr-2">Editar mensagem de WhatsApp</span>
                <span v-else class="mr-2">Adicionar mensagem de WhatsApp</span>
              </base-button>
            </b-overlay>
          </section>
        </section>
      </template>
    </b-modal>
  </section>
</template>
<script>
import { mapActions } from 'vuex'
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import XLSX from 'xlsx'
import { upload } from '@/utils/upload'

export default {
  name: 'ModalWhatsAppMessage',
  setup() {
    return { v$: useVuelidate() }
  },
  data() {
    return {
      phones: [],
      filePhones: {},
      checked: false,
      loadingOverlay: false,
      loading: false,
      tagsInstructionalVideos: [],
      templates: [],
      selectedTemplateHeaderFormat: null,
      headerFile: {},
      headerFileUploading: false,
      whatsAppMessage: {
        phones: [],
        triggerTag: null,
        message: null,
        templateName: null,
        templateLanguage: 'pt_BR',
        provider: 'META'
      }
    }
  },
  props: {
    whatsAppMessageId: { type: String, required: false, default: null }
  },
  computed: {
    errors() {
      return this.$store.getters['access/error']
    },

    requiresHeaderMedia() {
      return ['IMAGE', 'VIDEO', 'DOCUMENT'].includes(this.selectedTemplateHeaderFormat)
    },

    headerAccept() {
      switch (this.selectedTemplateHeaderFormat) {
        case 'IMAGE':
          return 'image/jpeg,image/png'
        case 'VIDEO':
          return 'video/mp4'
        case 'DOCUMENT':
          return 'application/pdf'
        default:
          return ''
      }
    },

    headerMaxSizeMb() {
      switch (this.selectedTemplateHeaderFormat) {
        case 'IMAGE':
          return 5
        case 'VIDEO':
          return 16
        case 'DOCUMENT':
          return 100
        default:
          return 0
      }
    },

    headerLabel() {
      switch (this.selectedTemplateHeaderFormat) {
        case 'IMAGE':
          return 'Imagem do cabeçalho'
        case 'VIDEO':
          return 'Vídeo do cabeçalho'
        case 'DOCUMENT':
          return 'Documento do cabeçalho'
        default:
          return 'Arquivo do cabeçalho'
      }
    }
  },
  validations() {
    return {
      whatsAppMessage: {
        triggerTag: {},
        templateName: { required }
      }
    }
  },
  methods: {
    ...mapActions('tags', {
      handleTagsInstructionalVideos: 'handleTagsInstructionalVideos'
    }),
    ...mapActions('whatsAppMessage', {
      handleCreate: 'handleCreate',
      handleGet: 'handleGet',
      handleUpdate: 'handleUpdate',
      handleGetWhatsAppTemplates: 'handleGetWhatsAppTemplates'
    }),

    deletePhones(){
      this.phones = []
    },

    formatPhone(phone) {
      if (!phone) {
        return ''
      }
      const cleaned = phone.replace(/\D/g, '')

      if (cleaned.length === 11) {
        return cleaned.replace(/^(\d{2})(\d{5})(\d{4})$/, '($1) $2-$3')
      }

      if (cleaned.length === 10) {
        return cleaned.replace(/^(\d{2})(\d{4})(\d{4})$/, '($1) $2-$3')
      }

      return phone
    },

    async uploadPhones(event) {
      try {
        await this.$store.dispatch('access/updateError', ``)
        const [file] = Array.from(event.target.files)
        this.filePhones = file
        this.phones = []
        const fileReader = new FileReader()
        fileReader.onload = async (event) => {
          const data = event.target.result
          const workbook = XLSX.read(data, {
            type: 'array'
          })

          if (!workbook.SheetNames || workbook.SheetNames.length === 0) {
            await this.$store.dispatch('access/updateError', 'A planilha não contém nenhuma aba.')
            this.filePhones = {}
            this.phones = []
            return
          }

          const firstSheetName = workbook.SheetNames[0]
          const firstSheet = workbook.Sheets[firstSheetName]

          if (!firstSheet) {
            await this.$store.dispatch('access/updateError', `Não foi possível ler a aba "${firstSheetName}".`)
            this.filePhones = {}
            this.phones = []
            return
          }

          const rows = XLSX.utils.sheet_to_json(firstSheet)
          if (!rows || rows.length === 0) {
            await this.$store.dispatch('access/updateError', 'A planilha está vazia.')
            this.filePhones = {}
            this.phones = []
            return
          }

          const getColumnValue = (row, columnName) => {
            const key = Object.keys(row).find((k) => k.trim().toLowerCase() === columnName)
            return key ? row[key] : undefined
          }

          if (!rows.some((x) => getColumnValue(x, 'telefone') !== undefined)) {
            await this.$store.dispatch('access/updateError', `Arquivo incorreto, use o arquivo modelo de exemplo!`)
          } else {
            this.phones = rows
              .map((x) => getColumnValue(x, 'telefone'))
              .filter((value) => value)
              .map((value) => value.toString().replace(/[^\d]/g, ''))
          }
        }
        fileReader.readAsArrayBuffer(file)

      } catch (e) {

      }
    },

    onSelectTemplate() {
      const t = this.templates.find((x) => x.name === this.whatsAppMessage.templateName)
      this.whatsAppMessage.message = t ? t.body : null
      this.whatsAppMessage.templateLanguage = t ? t.language : 'pt_BR'
      this.selectedTemplateHeaderFormat = t ? (t.headerFormat || null) : null
      this.headerFile = {}
      this.whatsAppMessage.fileUrl = null
      this.whatsAppMessage.fileName = null
    },

    async uploadHeaderFile(event) {
      try {
        await this.$store.dispatch('access/updateError', ``)
        const [file] = Array.from(event.target.files)
        if (!file) {
          return
        }

        const maxBytes = this.headerMaxSizeMb * 1024 * 1024
        if (this.headerMaxSizeMb && file.size > maxBytes) {
          await this.$store.dispatch('access/updateError', `O arquivo excede o tamanho máximo de ${this.headerMaxSizeMb} MB.`)
          return
        }

        this.headerFileUploading = true
        const url = await upload(file)
        if (!url) {
          await this.$store.dispatch('access/updateError', `Não foi possível enviar o arquivo. Tente novamente.`)
          this.headerFileUploading = false
          return
        }

        this.headerFile = file
        this.whatsAppMessage.fileUrl = url
        this.whatsAppMessage.fileName = file.name
        this.headerFileUploading = false
      } catch (e) {
        this.headerFileUploading = false
      }
    },

    exportToExcel() {
      const data = this.tagsInstructionalVideos.filter(x => x.tag === this.whatsAppMessage.triggerTag).map((x) => {
        return {
          Tag: x.tag,
          ['Descrição']: x.description,
          ['Gatilho/Tarefa/Rotina']: x['Gatilho/Tarefa/Rotina']
        }
      })

      const worksheet = XLSX.utils.json_to_sheet(data)
      const workbook = XLSX.utils.book_new()

      XLSX.utils.book_append_sheet(workbook, worksheet, 'Planilha1')
      XLSX.writeFile(workbook, `${this.whatsAppMessage.triggerTag}.xlsx`)
    },

    async showModal() {
      try {
        await this.$store.dispatch('access/updateError', ``)
        this.whatsAppMessage = {
          phones: [],
          triggerTag: null,
          message: null,
          templateName: null,
          templateLanguage: 'pt_BR',
          provider: 'META'
        }
        this.filePhones = {}
        this.phones = []
        this.selectedTemplateHeaderFormat = null
        this.headerFile = {}
        this.headerFileUploading = false
        const { items } = await this.handleTagsInstructionalVideos()

        this.tagsInstructionalVideos = items.map((x) => {
          return {
            ...x,
            tagDescription: `${x.description}${x.tag ? ` (${x.tag})` : ''}`
          }
        })

        const tpl = await this.handleGetWhatsAppTemplates()
        const templateItems = (tpl && tpl.data && tpl.data.items) || []
        this.templates = templateItems.map((t) => {
          return {
            ...t,
            label: t.name
          }
        })

        if (this.whatsAppMessageId) {
          this.loadingOverlay = true
          const { data: dataResponse } = await this.handleGet(this.whatsAppMessageId) || {}
          const { data } = dataResponse || {}
          const { phones } = data || {}
          this.phones = phones
          this.whatsAppMessage = data
          const selectedTemplate = this.templates.find((x) => x.name === this.whatsAppMessage.templateName)
          this.selectedTemplateHeaderFormat = selectedTemplate ? (selectedTemplate.headerFormat || null) : null
          if (this.whatsAppMessage.fileName) {
            this.headerFile = { name: this.whatsAppMessage.fileName }
          }
          this.loadingOverlay = false
        }
      } catch (e) {

      }
    },

    closeModalInstructionalVideos() {
      this.$bvModal.hide('modalWhatsAppMessage')
    },

    async submit() {
      try {
        await this.$store.dispatch('access/updateError', ``)
        const validate = await this.v$.$validate()
        if (!validate) {
          await this.$store.dispatch('access/updateError', `Preencha todos os campos corretamente`)
          this.loading = false
          return
        }

        this.whatsAppMessage.phones = this.phones && this.phones.length > 0
          ? this.phones.filter((x) => x).map((x) => x.toString().trim().replace(/[^\d]/g, ''))
          : []

        if ((!this.whatsAppMessage.phones || this.whatsAppMessage.phones.length <= 0) && !this.whatsAppMessage.triggerTag) {
          await this.$store.dispatch('access/updateError', `É necessário importar uma lista de telefones ou selecionar uma tag de gatilho!`)
          return
        }

        if (this.whatsAppMessage.phones && this.whatsAppMessage.phones.length > 0 && this.whatsAppMessage.triggerTag) {
          await this.$store.dispatch('access/updateError', `Importe apenas a lista de telefones ou selecione uma tag de gatilho.`)
          return
        }

        if (this.requiresHeaderMedia && !this.whatsAppMessage.fileUrl) {
          await this.$store.dispatch('access/updateError', `É necessário anexar o arquivo de cabeçalho do modelo selecionado.`)
          return
        }

        this.loading = true

        let response = {}
        if (this.whatsAppMessageId) {
          response = await this.handleUpdate(this.whatsAppMessage)
        } else {
          response = await this.handleCreate(this.whatsAppMessage)
        }
        const { data, status, errors } = response
        let message = errors
        let variant = 'danger'

        if (status === 200 || status === 201) {
          message = data.message
          variant = 'success'
        }

        this.$bvToast.toast(message, {
          title: 'Atenção',
          variant: variant,
          toaster: 'b-toaster-top-center',
          autoHideDelay: 5000
        })

        this.closeModalInstructionalVideos()
        this.loading = false
        this.$emit('load')
      } catch (e) {
        console.log(e)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.modal-instructional-videos {
  .header {
    .title {
      font-weight: 700;
      font-size: 18px;
      color: var(--navy-blue);
    }

    .sub-title {
      font-weight: 400;
      font-size: 15px;
      color: #808080;
    }

    .btn-add-tutorial {
      font-weight: 400;
      font-size: 15px;
      border: 1px solid #AEBBCD;
      border-radius: 6px;
      color: #6D7989;
      background: #FFFFFF;
    }
  }

  .link-model {
    text-decoration: underline;
    font-weight: 400;
    font-size: 14px;
    color: var(--navy-blue);
  }

  .file-uploaded {
    width: 100%;

    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;

    color: var(--navy-blue);
    border: 1px solid var(--navy-blue);

    padding: 6px 12px;

    border-radius: 4px;

    transition: all 0.2s ease-in-out;

    text-decoration: none;

    cursor: pointer;
  }

  .file-product {
    border-radius: 6.25px;
    border: 1px solid #808080;
    width: 100%;
    height: 40px;
    cursor: pointer;

    span {
      color: #808080;
      font-size: 15px;
      font-style: normal;
      font-weight: 500;
    }

    strong {
      color: #808080;
      font-size: 15px;
      font-weight: 700;
    }

  }

  .phones-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 8px;
    padding: 0;
  }

  label {
    font-weight: 700;
    font-size: 16px;
    color: #262626;
    margin-bottom: 0;
  }
}
.btn-cancel {
  background: transparent !important;
  border-radius: 6.25px !important;
  border: 1px solid var(--navy-blue) !important;

  span {
    color: var(--navy-blue);
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
  }
}

.btn-add {
  background: var(--navy-blue) !important;
  border-radius: 6.25px !important;
  border: 1px solid var(--navy-blue) !important;

  span {
    color: #ffffff;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
  }
}

</style>
